import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const terceroImporterSelectors = importerSelectors(
  'tercero.importer',
);

export default terceroImporterSelectors;
